import { useTranslation } from 'react-i18next';
import { toneOf, type Tone } from '@/ui';
import { RIDE_STATES, labelOf } from '../shared/labels';

/**
 * Display names for the gateway's ride codes in the active language. The codes and colours stay in
 * shared/labels.ts (other screens use them); the words come from the rides translations.
 */
export function useRideLabels() {
  const { t } = useTranslation('rides');
  const list = (key: 'lockMethods' | 'unlockMethods') => t(key, { returnObjects: true }) as readonly string[];
  const states = t('states', { returnObjects: true }) as Record<string, string>;
  return {
    /** Ride.state as a badge: label and tone; undefined for unknown codes. */
    state(code: number | null | undefined): { label: string; tone: Tone } | undefined {
      const s = code == null ? undefined : RIDE_STATES[code];
      return s && { label: states[String(code)] ?? s.label, tone: toneOf(s.color) };
    },
    lockMethod: (code: number | null | undefined) => labelOf(list('lockMethods'), code),
    unlockMethod: (code: number | null | undefined) => labelOf(list('unlockMethods'), code),
  };
}
